// Centralised data-testids for QA & fork agent
export const NAV = {
    logo: "nav-logo",
    linkApproach: "nav-link-approach",
    linkWork: "nav-link-work",
    linkAbout: "nav-link-about",
    linkCareers: "nav-link-careers",
    linkContact: "nav-link-contact",
    mobileToggle: "nav-mobile-toggle",
    mobileMenu: "nav-mobile-menu",
};

export const HERO = {
    section: "hero-section",
    headline: "hero-headline",
    subheading: "hero-subheading",
    ctaPrimary: "hero-cta-primary",
    ctaSecondary: "hero-cta-secondary",
};

export const APPROACH = {
    section: "approach-section",
    heading: "approach-heading",
    principleItem: (slug) => `approach-principle-${slug}`,
};

export const SERVICES = {
    section: "services-section",
    heading: "services-heading",
    item: (slug) => `service-${slug}`,
};

export const WORK = {
    section: "work-section",
    heading: "work-heading",
    placeholder: (i) => `work-placeholder-${i}`,
};

export const ABOUT = {
    section: "about-section",
    heading: "about-heading",
};

export const CONTACT = {
    section: "contact-section",
    heading: "contact-heading",
    email: "contact-email",
};

export const FOOTER = {
    section: "footer-section",
    wordmark: "footer-wordmark",
    linkPrivacy: "footer-link-privacy",
    linkTerms: "footer-link-terms",
    socialLinkedin: "footer-social-linkedin",
    socialInstagram: "footer-social-instagram",
    socialX: "footer-social-x",
};

export const CAREERS = {
    section: "careers-section",
    heading: "careers-heading",
    position: (id) => `careers-position-${id}`,
    empty: "careers-empty",
};
